import * as React from "react";

function HighlighterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M219.7 459.7c-11.6 10.7-26 14.1-39.6 10.1l-32.8 32.8c-6 6-14.1 9.4-22.6 9.4H40c-17.67 0-32-14.3-32-32v-4.7c0-8.5 3.37-16.6 9.37-22.6l72.81-72.8c-3.97-13.6-.6-28.9 10.12-39.6l42.8-43.7v-48c0-15.4 8.3-29.9 20.9-39L441.8 10.2C451 3.567 462.1 0 473.5 0c14.4 0 28.2 5.726 38.4 15.92l32.2 32.16c10.2 10.19 15 24.02 15 38.43 0 11.37-2.7 21.59-9.3 31.69L350.4 395.1c-9.1 13.5-23.6 20.9-39 20.9h-48l-43.7 43.7zm-28.6-143.2-51.2 52.1 51.5 51.5 52.1-52.1h67.9l16.1-22.5-113-113-23.4 16.1v67.9zm320-229.99c0-1.68.2-3.3-1-4.49l-33-32.16c-.3-1.19-1.9-1.86-3.6-1.86-1.3 0-2.6.42-3.7 1.19L254 204.1l101.9 101L510.8 90.21c.8-1.08.3-2.37.3-3.7zM142.7 439.3l-22-22L73.94 464h44.16l24.6-24.7z"
  }));
}

const ForwardRef = React.forwardRef(HighlighterIcon);
export default ForwardRef;